import { render, staticRenderFns } from "./ChatLink.vue?vue&type=template&id=2d3cb43e&functional=true&"
import script from "./ChatLink.vue?vue&type=script&lang=js&"
export * from "./ChatLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports